import { MdOutlineClose } from 'react-icons/md';

const AddPaymentGateway = ({ isOpen, closeModal, handleSubmit, handleChange, formData }) => {
  if (!isOpen) return null;


  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
      <div className='w-full max-w-3xl p-6 bg-white rounded-lg shadow-lg'>
        <div className='flex items-center justify-between mb-4'>
          <p className='text-lg font-bold '>Add Country</p>
          <div className='bg-[#15A14A26] rounded-full flex justify-center items-center h-7 w-7
           text-[#15A14A] cursor-pointer hover:bg-white ring ring-[#15A14A26] hover:scale-105 transition-all duration-700 blur-none'>
            <MdOutlineClose
              size={20}
              className='cursor-pointer '
              onClick={closeModal}
              title='Close'
            />
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="space-y-6"> 
            <div>
              <label htmlFor="country2" className="block mb-2 font-[500] text-[14px]">
                Add Country
              </label>
              <div className="relative">
                <select
                  id="country2"
                  name="country2"
                  value={formData.country2}
                  onChange={handleChange}
                  className="block w-full px-3 py-3 border border-gray-300 rounded-md outline-none appearance-none"
                >
                  <option value="UK">UK</option>
                  <option value="US">US</option>
                  <option value="CA">Canada</option>
                  <option value="AU">Australia</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
                  <svg className="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <label htmlFor="selectCountry" className="block mb-2 font-[500] text-[14px]">
                Select Country
              </label>
              <div className="relative">
                <select
                  id="selectCountry"
                  name="selectCountry"
                  value={formData.selectCountry}
                  onChange={handleChange}
                  className="block w-full px-3 py-3 border border-gray-300 rounded-md outline-none appearance-none"
                >
                  <option value="UK">UK</option>
                  <option value="US">US</option>
                  <option value="CA">Canada</option>
                  <option value="AU">Australia</option>
                </select>
                <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
                  <svg className="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                  </svg>
                </div>
              </div>
            </div>
            <div>
              <label htmlFor="apiIntegrate" className="block mb-2 font-[500] text-[14px]">
                API Integrate
              </label>
              <input
                type="text"
                id="apiIntegrate"
                name="apiIntegrate"
                placeholder="API Integrate"
                value={formData.apiIntegrate}
                onChange={handleChange}
                className="block w-full px-3 py-3 border border-gray-300 rounded-md outline-none"
              />
            </div>
            <div>
              <label htmlFor="rate" className="block mb-2 font-[500] text-[14px]">
                Rate (%)
              </label>
              <input
                type="text"
                id="rate"
                name="rate"
                placeholder="0.520 (%)"
                value={formData.rate}
                onChange={handleChange}
                className="block w-full px-3 py-3 border border-gray-300 rounded-md outline-none"
              />
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className="px-6 py-2 w-52 font-[600] text-white transition-colors bg-[#00811D] rounded-md hover:bg-green-700"
              >
                Done
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default AddPaymentGateway;
